import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ChannelArticleItemViewModel } from 'src/app/models/item.model';
import { PublisherAvatarComponent } from '../publisher-avatar/publisher-avatar.component';

@Component({
  selector: 'app-article-publisher',
  templateUrl: './article-publisher.component.html',
  styleUrls: ['./article-publisher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PublisherAvatarComponent]
})
export class ArticlePublisherComponent {
  @Input() item: ChannelArticleItemViewModel;
  @Input() showPublisherLink: boolean;
  @Output() selectChannel = new EventEmitter<number>();

  showChannel(event): void {
    event.stopPropagation();
    this.selectChannel.emit(this.item.channel.id);
  }
}
